const quota_table = {
    quota: {
        title: 'ข้อมูลพื้นฐาน',
        base_price: 'ราคาพื้นฐาน',
        mau_limit: 'ขีดจำกัด MAU',
        included_tokens: 'โทเคนที่รวมไว้',
    },
    application: {
        title: 'แอปพลิเคชัน',
        total: 'รวมแอปพลิเคชัน',
        m2m: 'แอปพลิเคชันเครื่องต่อเครื่อง',
        third_party: 'แอปพลิเคชัน OIDC/OAuth ของบุคคลที่สาม',
        saml_app: 'แอป SAML',
    },
    resource: {
        title: 'ทรัพยากร API',
        resource_count: 'จำนวนทรัพยากร',
        scopes_per_resource: 'สิทธิ์ต่อทรัพยากร',
    },
    branding: {
        title: 'UI และแบรนดิ้ง',
        custom_domain: 'โดเมนที่กำหนดเอง',
        custom_css: 'CSS ที่กำหนดเอง',
        logo_and_favicon: 'โลโก้และไอคอนเว็บไซต์',
        bring_your_ui: 'นำ UI ของคุณมาเอง',
        dark_mode: 'โหมดมืด',
        i18n: 'การแปลหลายภาษา',
    },
    user_authn: {
        title: 'การยืนยันตัวตนผู้ใช้',
        omni_sign_in: 'การเข้าสู่ระบบแบบ Omni',
        password: 'รหัสผ่าน',
        passwordless: 'เข้าสู่ระบบโดยไม่ต้องใช้รหัสผ่าน - อีเมลและ SMS',
        email_connector: 'ตัวเชื่อมต่ออีเมล',
        sms_connector: 'ตัวเชื่อมต่อ SMS',
        social_connectors: 'ตัวเชื่อมต่อโซเชียล',
        standard_connectors: 'ตัวเชื่อมต่อมาตรฐาน',
        built_in_email_connector: 'ตัวเชื่อมต่ออีเมลในตัว',
        mfa: 'การยืนยันตัวตนหลายปัจจัย',
        sso: 'SSO สำหรับองค์กร',
        impersonation: 'การสวมรอย',
    },
    user_management: {
        title: 'การจัดการผู้ใช้',
        user_management: 'การจัดการผู้ใช้',
        roles: 'บทบาท',
        machine_to_machine_roles: 'บทบาทเครื่องต่อเครื่อง',
        scopes_per_role: 'สิทธิ์ต่อบทบาท',
    },
    organizations: {
        title: 'องค์กร',
        organizations: 'องค์กร',
        organization: 'องค์กร',
        organization_count: 'จำนวนองค์กร',
        allowed_users_per_org: 'ผู้ใช้ต่อองค์กร',
        invitation: 'เชิญ (API การจัดการ)',
        org_roles: 'บทบาทองค์กร',
        org_permissions: 'สิทธิ์ขององค์กร',
        just_in_time_provisioning: 'การจัดสรรทันที',
    },
    support: {
        title: 'การสนับสนุน',
        community: 'ชุมชน',
        customer_ticket: 'การสนับสนุนผ่านตั๋ว',
        premium: 'พรีเมียม',
        email_ticket_support: 'การสนับสนุนตั๋วทางอีเมล',
        discord_private_channel: 'ช่องส่วนตัวบน Discord',
        premium_support: 'การสนับสนุนพรีเมียม',
        developer_onboarding: 'การเริ่มต้นสำหรับนักพัฒนา',
        solution_engineer_support: 'วิศวกรโซลูชัน',
        sla: 'SLA',
        dedicated_computing_resources: 'ทรัพยากรคอมพิวเตอร์เฉพาะ',
    },
    compliance: {
        title: 'การปฏิบัติตาม',
        soc2_compliant: 'ผ่านมาตรฐาน SOC2',
        soc2_report: 'รายงาน SOC2',
        hipaa_or_baa_report: 'รายงาน HIPAA/BAA',
    },
    developers_and_platform: {
        title: 'นักพัฒนาและแพลตฟอร์ม',
        hooks: 'Webhook',
        audit_logs_retention: 'ระยะเวลาการเก็บบันทึกการตรวจสอบ',
        jwt_claims: 'การเคลม JWT',
        tenant_members: 'สมาชิก Tenant',
    },
    unlimited: 'ไม่จำกัด',
    contact: 'ติดต่อ',
    monthly_price: '${{value, number}}/เดือน',
    days: '{{count, number}} วัน',
    days_other: '{{count, number}} วัน',
    add_on: 'ส่วนเสริม',
    tier: 'ระดับ{{value, number}}: ',
    million: '{{value, number}} ล้าน',
    mau_tip: 'MAU (ผู้ใช้ที่ใช้งานต่อเดือน) หมายถึงจำนวนผู้ใช้ที่ไม่ซ้ำกันซึ่งได้แลกเปลี่ยนโทเคนอย่างน้อยหนึ่งรายการกับ Logto ในรอบบิลหนึ่งรอบ',
    tokens_tip: 'โทเคนทุกประเภทที่ออกโดย Logto รวมถึง access token, refresh token และอื่น ๆ',
    mao_tip: 'MAO (องค์กรที่ใช้งานรายเดือน) หมายถึงจำนวนองค์กรที่ไม่ซ้ำกันที่มี MAU อย่างน้อยหนึ่งรายในรอบบิล',
    third_party_tip: 'ใช้ Logto เป็นผู้ให้บริการข้อมูลประจำตัว OIDC ของคุณสำหรับการลงชื่อเข้าใช้และการให้สิทธิ์เข้าใช้แอปของบุคคลที่สาม',
    included: 'รวม {{value, number}}',
    included_mao: 'รวม {{value, number}} MAO',
    extra_quota_price: 'หลังจากนั้น ${{value, number}} ต่อเดือน / รายการ',
    extra_token_price: 'หลังจากนั้น ${{value, number}} ต่อเดือน / {{amount, number}} รายการ',
    per_month_each: '${{value, number}} ต่อเดือน / รายการ',
    extra_mao_price: 'หลังจากนั้น ${{value, number}} ต่อ MAO',
    per_month: '${{value, number}} ต่อเดือน',
    per_member: 'หลังจากนั้น ${{value, number}} ต่อสมาชิก',
};
export default Object.freeze(quota_table);
